import {environment as env} from './../../../environments/environment';
import {HttpHeaders} from '@angular/common/http';


export class Config {
  public static BASE_URL = env.api.BASE_URL;

  public headers: any = {};

  /**
   * setHeaders
   * @description this is use to set request header if it a json request
   */
  public setHeaders(): HttpHeaders {
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json');
    headers.set('Accepts', 'application/json');
    return headers;
  }

}


export const CUSTOM_CONSTANTS = {
  DEFAULT_ERROR_MESSAGE: 'Error',
  DEFAULT_SUCCESS_MESSAGE: 'Success',
  FILE_UPLOAD: 'Success',
  UNAUTHENTICATED: 'Unauthenticated',
  APP_VARIABLE: 'EDMS',
  INVALID_DATA: 'The given data is invalid',
  ITEMS_PER_PAGE: [10, 25, 50, 100]
};
